import { Component } from '@angular/core';

@Component({
    selector: 'app-not-found',
    standalone: true,
    imports: [],
    template: `
        <div class="h-full w-full flex flex-column align-items-center justify-content-center text-primary">
            <img
                src="assets/icons/no-result-found.svg"
                alt="Page not found"
                style="width: 300px; height: auto; margin-bottom: 1rem"
            />
            <h2>404 | {{ message }}</h2>
        </div>
    `,
})
export class NotFoundComponent {
    message = 'Page not found';

    constructor() {
        const navigationState = history.state;
        if (navigationState?.message) {
            this.message = navigationState.message;
        }
    }
}
